import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=50dbda96&scoped=true&"
import script from "./BookingEdit.vue?vue&type=script&lang=js&"
export * from "./BookingEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookingEdit.vue?vue&type=style&index=0&id=50dbda96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbda96",
  null
  
)

export default component.exports